import { logger } from '@mail-core/logger';

const log = (...params) => {
    logger.verbose('[pushApiFetch]', ...params);
};

export class PushApiFetch {
    token?: string;
    lastSDCRequestTs = 0;
    email: string;

    constructor(email: string) {
        this.email = email;
    }

    private fetchSDC(): Promise<void> {
        const currentTs = Date.now();

        if (this.lastSDCRequestTs && currentTs - this.lastSDCRequestTs < 1000) {
            return Promise.reject(new Error('Too many SDC requests'));
        }

        this.lastSDCRequestTs = currentTs;

        const sdcUrl = `https://auth.mail.ru/sdc?from=${encodeURIComponent(
            `${location.protocol}//${location.host}`
        )}&dataType=jsonp&jsonp=JSONP_callback`;

        return fetch(sdcUrl, {
            method: 'GET',
            mode: 'no-cors',
            credentials: 'include',
        }).then(() => {
            return undefined;
        });
    }

    private async handleNoSDC() {
        await this.fetchSDC();
        await this.fetchToken();
    }

    private async fetchToken() {
        try {
            const res = await fetch('/api/v3/tokens/csrf', {
                method: 'POST',
            });

            const data = await res.json();

            if (res.status === 403 && data?.error === 'nosdc') {
                return { status: 403, err: 'nosdc' };
            }

            this.token = data?.token;

            return { token: data?.token };
        } catch (err) {
            log('Fetch token error', err);
        }
    }

    async makeRequest(url, body) {
        if (!this.token) {
            const tokenData = await this.fetchToken();

            if (tokenData?.err) {
                await this.handleNoSDC();
            }
        }

        if (!this.token) {
            return;
        }

        try {
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'x-email': this.email,
                    'content-type': 'application/json;charset=UTF-8',
                    'X-CSRF-Token': this.token,
                },
                credentials: 'include',
                mode: 'cors',
                body: JSON.stringify(body),
            });

            return await res.json();
        } catch (err) {
            log(`Make request ${url} error `, err);
        }
    }
}
